"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import Image from "next/image"
import { Search, Filter } from "lucide-react"
import { Input } from "@/components/ui/input"
import { LIST_IMAGE } from "@/assets"

interface Product {
  id: number
  name: string
  description: string
  image: any
  category: string
  price: string
  features: string[]
  specifications: string[]
}

const categories = [
  "Tất cả",
  "Dây buộc & Dây thừng",
  "Lưới bảo hộ & xây dựng",
  "Dây đai đóng gói",
  "Phụ gia & Vật liệu xây dựng",
  "Thảm công nghiệp & Trang trí",
  "Chỉ may công nghiệp",
];


export const products: Product[] = [
  {
    id: 1,
    name: "Dây thừng đa dụng",
    description: "Dây thừng đa công năng làm từ sợi PP Multi được sử dụng để chằng buộc đồ đạc – hàng hóa, căng lều bạt, trang trí vật dụng – đồ dùng và các nhu cầu khác…",
    image: LIST_IMAGE.product1,
    category: "Dây buộc & Dây thừng",
    price: "Liên hệ",
    features: ["Độ bền cao", "Chống thấm nước", "Chịu lực tốt"],
    specifications: ["Chất liệu: Sợi PP", "Đường kính: 4mm - 12mm", "Chiều dài: Tùy chọn"],
  },
  {
    id: 2,
    name: "Lưới an toàn",
    description: "Lưới an toàn có tác dụng chống rơi cho các công trình xây dựng cao tầng, các khu vực vui chơi, nhà banh, cầu trượt, trò chơi cảm giác mạnh…",
    image: LIST_IMAGE.product2,
    category: "Lưới bảo hộ & xây dựng",
    price: "Liên hệ",
    features: ["Chống rơi hiệu quả", "Chịu lực cao", "An toàn cho trẻ em và công trình"],
    specifications: ["Chất liệu: Sợi PP hoặc PE", "Kích thước ô lưới: 5x5cm / 10x10cm", "Màu sắc: Xanh, trắng, vàng"],
  },
  {
    id: 3,
    name: "Dây đai dệt PP",
    description: "Với độ bền cao, căng giữ tốt, khả năng hấp thụ sốc, dây đai từ sợi PP Multi được sử dụng để chằng buộc trong vận chuyển hàng hóa xe moóc phẳng, container, xe tải mở",
    image: LIST_IMAGE.product3,
    category: "Dây đai đóng gói",
    price: "Liên hệ",
    features: ["Căng chắc", "Không bị giãn", "Chịu tải trọng lớn"],
    specifications: ["Chất liệu: Sợi PP dệt", "Chiều rộng: 15mm - 50mm", "Độ dày: 0.5 - 1.5mm"],
  },
  {
    id: 4,
    name: "Gia cường bê tông",
    description: "Khi trộn vào vữa bê tông, sợi PP Multi cho ra sản phẩm bê tông có chất lượng vượt trội như phân tán tốt, khả năng liên kết mạnh, giúp chống nứt, chống thấm (cho bể bơi, bể chứa), tăng cường lực cho bê tông. Đặc biệt sử dụng cho kỹ thuật bề mặt công trình, sàn, đường, công trình biển.",
    image: LIST_IMAGE.product4,
    category: "Phụ gia & Vật liệu xây dựng",
    price: "Liên hệ",
    features: ["Chống nứt bê tông", "Chống thấm", "Tăng cường độ chịu lực"],
    specifications: ["Chiều dài sợi: 6mm - 20mm", "Tỉ lệ pha trộn: 0.9kg/m³", "Chất liệu: PP Fibers"],
  },
  {
    id: 5,
    name: "Thảm PP Multi",
    description: "Thảm từ sợi PP Multifilament có độ mềm mại, bền, khả năng chống mài mòn và tính thẩm mỹ cao, thích hợp cho các khu vực có lưu lượng giao thông lớn như khách sạn, văn phòng. Ngoài ra, đặc tính chống ẩm mốc, khó bết bẩn, hoàn toàn phù hợp với thời tiết nóng ẩm của Việt Nam.",
    image: LIST_IMAGE.product5,
    category: "Thảm công nghiệp & Trang trí",
    price: "Liên hệ",
    features: ["Chống ẩm mốc", "Chống mài mòn", "Thẩm mỹ cao"],
    specifications: ["Chất liệu: Sợi PP", "Độ dày: 5mm - 15mm", "Kích thước: Tùy chỉnh theo yêu cầu"],
  },
  {
    id: 6,
    name: "Chỉ may bao bì",
    description: "Nhờ vào các đặc tính nổi bật như độ bền cao, khả năng chịu lực, kháng hóa chất, đặc biệt là khả năng chống thấm nước tự nhiên (so với sợi chỉ may làm từ sợi Polyester), sợi PP Multi được sử dụng làm chỉ may bao bì nông sản, thực phẩm, bao bì công nghiệp, bao bì xuất khẩu",
    image: LIST_IMAGE.product6,
    category: "Chỉ may công nghiệp",
    price: "Liên hệ",
    features: ["Chống thấm", "Độ bền cao", "Kháng hóa chất"],
    specifications: ["Chất liệu: PP Multi", "Kích cỡ: Từ 200D đến 3000D", "Ứng dụng: May bao bì PP, PE, Kraft"],
  },
]


export default function ProductCatalog() {
  const [selectedCategory, setSelectedCategory] = useState("Tất cả")
  const [searchTerm, setSearchTerm] = useState("")

  const filteredProducts = products.filter((product) => {
    const matchesCategory = selectedCategory === "Tất cả" || product.category === selectedCategory
    const matchesSearch =
      product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.description.toLowerCase().includes(searchTerm.toLowerCase())
    return matchesCategory && matchesSearch
  })

  return (
    <div className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-cente">
          <h1 className="text-4xl md:text-5xl font-bold text-black mb-4">Sản Phẩm Của Chúng Tôi</h1>
          <p className="text-xl text-gray-600 max-w-3l mx-auto mb-5">
          Công ty Cổ phần Sợi Cửu Long cung cấp các loại sợi PP Multifilament chất lượng cao, đa dạng, đáp ứng  rộng rãi nhu cầu khách hàng trong nhiều lĩnh vực: dây buộc & dây thừng, lưới bảo hộ & xây dựng, dây đai đóng gói, bê tông gia cường, thảm, chỉ may...
          </p>
        </div>

        {/* Search and Filter */}
        <div className="mb-8 space-y-4">
          <div className="flex flex-col md:flex-row gap-4 items-center">
            <div className="relative flex-1 max-w-md">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
              <Input
                placeholder="Tìm kiếm sản phẩm..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10"
              />
            </div>
            <div className="flex items-center gap-2">
              <Filter className="h-4 w-4 text-gray-600" />
              <span className="text-sm text-gray-600">Danh mục:</span>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            {categories.map((category) => (
              <Button
                key={category}
                variant={selectedCategory === category ? "default" : "outline"}
                size="sm"
                onClick={() => setSelectedCategory(category)}
                className={selectedCategory === category ? "bg-primary hover:bg-primary/90" : ""}
              >
                {category}
              </Button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product) => (
            <Card key={product.id} className=" rounded-none overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-64">
                <Image src={product.image || "/placeholder.svg"} alt={product.name} fill className="object-cover" />
                <Badge className="absolute top-4 left-4 bg-primary text-[#555555]">{product.category}</Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-secondary">{product.name}</CardTitle>
                <CardDescription className="text-gray-600">{product.description}</CardDescription>
              </CardHeader>

            </Card>
          ))}
        </div>

        {filteredProducts.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">Không tìm thấy sản phẩm nào phù hợp.</p>
          </div>
        )}
      </div>
    </div>
  )
}
